import { useMutation } from '@tanstack/vue-query'
import { useHttp, useTranslate } from '@/shared/lib'
import { useNotification } from '@/shared/ui'

export const useSendForm = () => {
  const http = useHttp()
  const { addError, addSuccess } = useNotification()
  const { trs } = useTranslate()

  const mutation = useMutation({
    mutationFn: (data: any) => {
      return http.post('/objects/replace', data)
    },
  })

  const sendForm = async (data: any) => {
    try {
      await mutation.mutateAsync(data)

      addSuccess(trs('itf.replaced'))
    } catch (error: any) {
      addError(trs(error?.response?.data?.data?.msg || 'request.unknown_error'))

      throw error
    }
  }

  return {
    ...mutation,

    sendForm,
  }
}
